import api from '../config/axios-conf';

export const getActiveBanking = (shopId) =>
    api.get(`/banking-info/shop/${shopId}/active`);

export const getAllBanking = (shopId) =>
    api.get(`/banking-info/shop/${shopId}`);

export const createBanking = (data) =>
    api.post('/banking-info', data);

export const updateBanking = (id, data) =>
    api.put(`/banking-info/${id}`, data);

export const toggleBankingActive = (id) =>
    api.put(`/banking-info/${id}/toggle-active`);

export const deleteBanking = (id) =>
    api.delete(`/banking-info/${id}`);
